import paths from 'constants/paths';
import { isUnderPath, useIsUnderPaths } from 'utils/hooks/isUnderPath';

export const isUnderOperationPortalPath = (pathname) =>
  isUnderPath([paths.operation.root], pathname);
export const useIsUnderOperationPortalPath = () => useIsUnderPaths([paths.operation.root]);
